//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import QuestionContainer from '~/components/faq/QuestionContainer.vue'
import APIloading from '~/components/common/APILoading.vue'
import APIFailed from '~/components/common/APIFailed.vue'
import FooterTop from '~/components/footer/footerTop.vue'

export default {
  components: {
    TopScreen,
    QuestionContainer,
    APIloading,
    APIFailed,
    FooterTop
  },
  data () {
    return {
      faq: [],
      fetched: false,
      fetchError: false
    }
  },
  async fetch () {
  //   try {
  //     const posts = await fetch('https://api.pagsmile.com/index.php?r=api%2Ffaq')
  //       .then(res => res.json())
  //       .catch(function (e) {
  //         console.log(e)
  //       })
  //     let filteredPosts = []
  //     // console.log(posts)
  //     if (posts.length) {
  //       const locale = this.$i18n.locale
  //       if (locale === 'en') {
  //         filteredPosts = posts.filter(post => (Number(post.lang_id) === 2 && Number(post.status) === 1)) || []
  //       }
  //       if (locale === 'pt') {
  //         filteredPosts = posts.filter(post => (Number(post.lang_id) === 3 && Number(post.status) === 1)) || []
  //       }
  //       if (locale === 'zh') {
  //         filteredPosts = posts.filter(post => (Number(post.lang_id) === 1 && Number(post.status) === 1)) || []
  //       }
  //       if (locale === 'es') {
  //         filteredPosts = posts.filter(post => (Number(post.lang_id) === 4 && Number(post.status) === 1)) || []
  //       }
  //     }
  //     this.fetched = true
  //     if (filteredPosts.length) {
  //       this.faq = filteredPosts
  //       return
  //     } else {
  //       // Default to english language
  //       filteredPosts = posts.filter(post => (Number(post.lang_id) === 2 && Number(post.status) === 1)) || []
  //       if (filteredPosts.length) {
  //         this.faq = filteredPosts
  //         return
  //       }
  //     }
  //     this.faq = []
  //   } catch (err) {
  //     console.log('err', err)
  //     this.posts = []
  //     this.fetched = true
  //     this.fetchError = true
  //   }
  },
  // fetchOnServer: false,
  head () {
    return {
      title: this.$t('faq.top-title').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  mounted () {
    this.clientFetch()
  },
  methods: {
    clientFetch () {
      this.$fetch()
    }
  }
}
